// extracted by mini-css-extract-plugin
export default {"page":"AppRedirectPage_page__NkcRW","logo":"AppRedirectPage_logo__njG96","text":"AppRedirectPage_text__JUqHU"};